<div class="upload-section flex-column justify-content-center center">
  <mat-card appearance="outlined">
    @if (isDivision) {
      <mat-form-field>
        <mat-select placeholder="Select Warehouse" floatPlaceholder="never" [(ngModel)]="selectedWarehouseId" name="warehouseId" (ngModelChange)="selectWarehouse($event)"
          required>
          @for (warehouse of (warehouseList$ | async); track warehouse) {
            <mat-option [value]="warehouse.id">
              {{warehouse.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (!isDivision) {
      <mat-form-field>
        <mat-select placeholder="Select Project" floatPlaceholder="never" [(ngModel)]="selectedProjectId" name="projectId" (ngModelChange)="selectProject($event)"
          required>
          @for (project of (projectList$ | async); track project) {
            <mat-option [value]="project.id">
              {{project.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </mat-card>

  @if ((selectedProjectId && projectCurrencies && projectCurrencies.length > 1)) {
    <mat-card appearance="outlined">
      <mat-form-field>
        <mat-select placeholder="Select Currency" floatPlaceholder="never" [(ngModel)]="selectedCurrencyId" name="currencyId" required>
          @for (currency of projectCurrencies; track currency) {
            <mat-option [value]="currency.id">
              {{currency.accounting_code}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-card>
  }
</div>
<div class="flex-column justify-content-center center">
  <p-fileUpload class="ui-shadow-1" [ngStyle]="{'flex':'1'}" name="assetsFile" url="/api/asset-imports"
    invalidFileTypeMessageDetail='only XLS and XLSX files are supported for asset files.'
    invalidFileTypeMessageSummary='Invalid file type,' (onUpload)="onUpload($event)" (onError)="onError($event)"
    (onBeforeUpload)="onBeforeUpload($event)" [disabled]="disableUpload" (onSelect)="onFileSelect($event)" (onRemove)="onRemove()" (onBeforeSend)="onBeforeSend()" mode="advanced">
    <ng-template #empty>
      @if (!isShowDragContent) {
        <p class="content-message">Drop  Your File Here</p>
      }
    </ng-template>

  </p-fileUpload>
  @if (errorMsg?.length) {
    @for (item of errorMsg; track item) {
      <p-message [closable]="false" class="wk-flex-fix" style="flex:1;" [severity]="item.severity">
        <div class="p-message-wrapper">
           <i class="pi" [ngClass]="{
            'pi-info-circle': item.severity === 'info',
            'pi-check-circle': item.severity === 'success',
            'pi-exclamation-triangle': item.severity === 'warn',
            'pi-times-circle': item.severity === 'error'
          }"></i>
          <span class="p-message-summary">{{ item.summary }}</span>
          <span class="p-message-detail">{{ item.detail }}</span>
        </div>
      </p-message>
    }
  }
</div>
